import { FunctionComponent, memo } from "react";
import { IProps } from "./select-time-zone.types";
import { useTimeZones } from "hooks-for/time-zones/use-time-zone";
import { SelectField } from "@edgetier/select";
import "./select-time-zone.scss";

/**
 * A dropdown select for choosing time-zone(s)
 * @param props.name        The name of the select field
 * @param props.otherProps  Other props for the field
 */
const SelectTimeZone: FunctionComponent<IProps> = ({ name, ...otherProps }) => {
    const { data, isLoading } = useTimeZones();

    return (
        <SelectField
            isLoading={isLoading}
            items={data ?? []}
            name={name}
            getLabel={({ timeZone }) => timeZone}
            getValue={({ timeZoneId }) => timeZoneId}
            description="time zone"
            {...otherProps}
        />
    );
};

export default memo(SelectTimeZone);
